export default "__VITE_ASSET__BlE3yORC__"